import React, { useEffect, useState } from 'react';

import clsx from 'clsx';

import { makeStyles } from '@material-ui/styles';
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Divider
} from '@material-ui/core';

import { StatBox } from 'views/Reports/components';
import { types as emailStatBoxTypes } from 'views/Reports/constants';
const useStyles = makeStyles(theme => ({
  root: {},
  statBoxCard: { marginBottom: theme.spacing(3) },
  cardAction: { paddingTop: '10px', marginRight: theme.spacing(1) },
  sectionTitle: { marginBottom: theme.spacing(3) }
}));

const StatCardBox = props => {
  const {
    report,
    action,
    hideHeaderTitle = false,
    ...rest
  } = props;
  const {
    reportData,
    queryData,
    isLoading,
    getEmailStats,
    getSmsStats,
    unsubscribeCount
  } = report;
  const [stats, setStats] = useState([]);
  const [heading, setHeading] = useState('');

  const classes = useStyles();
  const shouldShowHeader = !hideHeaderTitle;

  useEffect(() => {
    let totalEmailCount = (reportData ?.totalMetrics ?.totalRequested ?.totalCount) || 0;
    let statBoxes;
    if (queryData ?.type === 'SMS') {
      statBoxes = getSmsStats(reportData);
      setHeading('SMS')
    } else {
      statBoxes = getEmailStats(reportData);
      setHeading(`Emails Sent ${isLoading ? '' : '(' + totalEmailCount + ')'}`)
    }
    setStats(statBoxes);
  }, [reportData, queryData, unsubscribeCount])

  const requestedCount = reportData?.totalMetrics?.totalRequested?.totalCount || 0;
  const acceptedCount = reportData?.totalMetrics?.undeliveredMetrics?.totalAccepted?.totalCount || 0;
  const deliveredCount = reportData?.totalMetrics?.totalDelivered?.totalCount || 0;
  const openedCount = reportData?.totalMetrics?.totalOpened?.totalCount || 0;
  const clickedCount = reportData?.totalMetrics?.totalClicked?.totalCount || 0;

  const acceptedRate = requestedCount > 0 ? Math.round((acceptedCount / requestedCount) * 100) : 0;
  const deliveredRate = acceptedCount > 0 ? Math.round((deliveredCount / acceptedCount) * 100) : 0;
  const openRate = deliveredCount > 0 ? Math.round((openedCount / deliveredCount) * 100) : 0;
  const clickRate = openedCount > 0 ? Math.round((clickedCount / openedCount) * 100) : 0;

  const displayStats = queryData?.type === 'EMAIL'
    ? stats.map(box => {
        if (box.statType === emailStatBoxTypes.REQUESTED) {
          return box;
        }

        if (box.statType === emailStatBoxTypes.ACCEPTED) {
          return {
            ...box,
            subStatText: `${acceptedRate}% Acceptance Rate`,
            subStatTooltip: `${acceptedCount} Accepted out of ${requestedCount} Requested`,
            subStatValue: acceptedRate
          };
        }

        if (box.statType === emailStatBoxTypes.DELIVERED) {
          return {
            ...box,
            subStatText: `${deliveredRate}% Delivery Rate`,
            subStatTooltip: `${deliveredCount} Delivered out of ${acceptedCount} Accepted`,
            subStatValue: deliveredRate
          };
        }

        if (box.statType === emailStatBoxTypes.OPENED) {
          return {
            ...box,
            subStatText: `${openRate}% Open Rate`,
            subStatTooltip: `${openedCount} Opened out of ${deliveredCount} Delivered`,
            subStatValue: openRate
          };
        }

        if (box.statType === emailStatBoxTypes.CLICKED) {
          return {
            ...box,
            subStatText: `${clickRate}% Click Rate`,
            subStatTooltip: `${clickedCount} Clicked out of ${openedCount} Opened`,
            subStatValue: clickRate
          };
        }

        return box;
      })
    : stats;

  return (
    <div className={classes.root}>
      <Card {...rest} className={clsx(classes.statBoxCard)}>
        {shouldShowHeader && (
          <>
            <CardHeader
              title={!isLoading && heading}
              action={action}
              classes={{ action: classes.cardAction }}
            />
            <Divider />
          </>
        )}
        <CardContent>
          <Grid container spacing={4}>
            {displayStats.map((box, i) => (
              <Grid key={i} item lg={3} sm={6} xl={2} xs={12}>
                <StatBox
                  currentStat={box.currentStat}
                  previousStat={1029}
                  period="day"
                  statType={box.statType}
                  isReportLoading={isLoading}
                  subStatText={box.subStatText}
                  subStatTooltip={box.subStatTooltip}
                  subStatValue={box.subStatValue}
                />
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
};

export default StatCardBox;
